export const MODAL_SIZE_SM = 'sm'
export const MODAL_SIZE_MD = 'md'
export const MODAL_SIZE_LG = 'lg'
